<template>
    <SmartBreadcrumbs
        type="InertiaLink"
        :pages="[
            {
                name: $tc('messages.groups', 2),
                href: meta.links.index,
            },
            {
                name: $tc('messages.students', 2),
                href: null,
            },
            {
                name: $t('messages.edit'),
                href: null,
            },
        ]"
    />
    <div class="flex justify-end">
        <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" form="group_student" />
    </div>
    <form :action="meta.links.update" method="post" @submit.prevent="submit" class="mt-3" id="group_student">
        <table class="min-w-full divide-y divide-gray-200 relative">
            <thead class="sticky top-0 bg-gray-50 z-10">
                <tr>
                    <th
                        class="sticky left-0 px-4 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                        {{ $t('messages.student') }}
                    </th>
                    <th
                        v-for="group in options.groups"
                        :key="group.id"
                        class="px-4 py-3 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                        <div class="flex justify-center items-center space-x-2">
                            <span>
                                {{ group.name }}
                            </span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="odd:bg-white even:bg-gray-50" v-for="(student, index) in form.students" :key="student.id">
                    <td
                        class="sticky left-0 px-4 py-2 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 z-10"
                        :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                    >
                        <span> {{ student.full_name }} </span>
                        <span class="text-gray-400 text-xs"> ({{ student.group_name }}) </span>
                    </td>
                    <td
                        v-for="group in options.groups"
                        :key="group.id"
                        class="text-center px-4 py-2 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 relative"
                    >
                        <label
                            class="absolute inset-0 flex justify-center items-center"
                            :class="{ 'bg-indigo-100': student.group_id == group.id }"
                        >
                            <input
                                type="radio"
                                :name="`student_${student.id}_group`"
                                id=""
                                :value="group.id"
                                v-model="student.group_id"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            />
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>
    </form>
    <div class="flex justify-end p-2">
        <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" form="group_student" />
    </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'students', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                students: this.students,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
